import { useQueryClient } from '@tanstack/react-query';
import { useState, type FormEvent } from 'react';
import { useNavigate } from 'react-router-dom';
import { Aviso, Botao, Campo } from '../componentes/forma.tsx';
import { Caetech, Marca } from '../componentes/Marca.tsx';
import { api, ErroApi } from '../lib/api.ts';
import { inicioDoPapel, type Papel } from '../lib/sessao.tsx';
import './entrar.css';

export function Entrar() {
  const [email, setEmail] = useState('');
  const [senha, setSenha] = useState('');
  const [erro, setErro] = useState('');
  const [enviando, setEnviando] = useState(false);
  const qc = useQueryClient();
  const navegar = useNavigate();

  async function enviar(e: FormEvent) {
    e.preventDefault();
    setErro('');
    setEnviando(true);
    try {
      const quem = await api.post<{ trocarSenha: boolean; papel: Papel; podeLaudar?: boolean }>('/auth/entrar', {
        email,
        senha,
      });
      await qc.invalidateQueries({ queryKey: ['sessao'] });
      // Cada papel tem a própria tela inicial: recepção vai para a fila, médico
      // para os exames a laudar, empresa para os exames dos funcionários.
      navegar(quem.trocarSenha ? '/senha' : inicioDoPapel(quem.papel, quem.podeLaudar !== false), { replace: true });
    } catch (e) {
      setErro(e instanceof ErroApi ? e.message : 'Não foi possível entrar.');
      setEnviando(false);
    }
  }

  return (
    <div className="entrar">
      {/* O negatoscopio: o cartao e a chapa iluminada contra a sala escura. */}
      <div className="entrar__luz" aria-hidden="true" />

      <main className="entrar__painel">
        <header className="entrar__marca">
          <Marca tamanho="lg" subtitulo="Sistema de exames radiográficos" />
        </header>

        <form className="entrar__forma" onSubmit={(e) => void enviar(e)} noValidate>
          {erro && <Aviso>{erro}</Aviso>}

          <Campo
            rotulo="Acesso"
            name="email"
            autoComplete="username"
            autoFocus
            required
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            dica="E-mail da clínica, CRM do médico ou CNPJ da empresa."
          />
          <Campo
            rotulo="Senha"
            type="password"
            name="senha"
            autoComplete="current-password"
            required
            value={senha}
            onChange={(e) => setSenha(e.target.value)}
          />

          <Botao type="submit" variante="primario" carregando={enviando}>
            {enviando ? 'Entrando…' : 'Entrar'}
          </Botao>
        </form>

        <p className="entrar__ajuda">
          Esqueceu a senha? Peça à clínica para redefinir.
        </p>
        <Caetech className="entrar__caetech" />
      </main>
    </div>
  );
}
